import { get } from './http';

// Types sourced from https://github.com/ev-proddev/user-content
// Paths below are relative to that repo root (user-content-dto/src/main/java/com/experticity/content/dto/).

// ── Types ─────────────────────────────────────────────────────────────────────

/** @sync-ignore — embedded type within FeedSummaryDto; source uncertain (may originate in ev-proddev/campaign, not user-content) */
export type FeedSummaryCategory = {
  id: number;
  name: string;
};

/** @source FeedSummaryDto.java */
export type FeedSummary = {
  campaignCount: number;
  learnCount: number;
  orgCount: number;
  shopCount: number;
  socialCount: number;
  categories: FeedSummaryCategory[];
};

// ── API ───────────────────────────────────────────────────────────────────────

export function getFeedSummary(): Promise<FeedSummary> {
  return get<FeedSummary>('/xapi/user-content/ext/1.0/feedContent/summary');
}
